import { Control } from "./control";
import { EventHandler } from "..";

type TextFieldReceiver<T> = (item: T) => any;
type DisabledFieldReceiver<T> = (item: T) => boolean;

export class CheckBoxSelectChangedEventArgs<T = any> {
    items!: T[];
}

export class CheckBoxSelect<T = any> extends Control {
    public items: T[] = [];
    public label = "";
    public containerClass: string = "";

    public textField: TextFieldReceiver<T> = (item: T) => item;
    public disabledField: DisabledFieldReceiver<T> = (item: T) => false;

    public getComponentName(): string {
        return "CheckBoxSelectComponent";
    }

    private _selectedItems: T[] = [];
    public get selectedItems(): T[] {
        return this._selectedItems;
    }
    public set selectedItems(items: T[]) {
        if (items === this._selectedItems) {
            return;
        }

        this._selectedItems = items;
        this.notifyChangedHandlers();
    }

    private _changedHandlers = new Set<EventHandler<CheckBoxSelectChangedEventArgs<T>>>();
    public addChangedHandler(handler: EventHandler<CheckBoxSelectChangedEventArgs<T>>): void {
        this._changedHandlers.add(handler);
    }
    public removeChangedHandler(handler: EventHandler<CheckBoxSelectChangedEventArgs<T>>): void {
        this._changedHandlers.delete(handler);
    }
    private notifyChangedHandlers(): void {
        const args: CheckBoxSelectChangedEventArgs<T> = { items: this._selectedItems };
        for (const handler of this._changedHandlers) {
            handler(this, args);
        }
    }
}
